export const FB_AUTH_REQUESTS = "FB_AUTH_REQUESTS";
export const FB_AUTH_REQUESTS_SUCCESS = "FB_AUTH_REQUESTS_SUCCESS";
export const FB_AUTH_REQUESTS_FAIL = "FB_AUTH_REQUESTS_FAIL";